module.exports = __webpack_public_path__ + "img/outDefault.ed0e17b3.svg";